import { useObservable } from "micro-observables";
import { useServices } from "@core/servicesContext";

export function usePrivacyValidated(): boolean {
	const { privacyService } = useServices();
	return useObservable(privacyService.privacyValidated);
}
